import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=26004f28"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26004f28')) {
      api.createRecord('26004f28', component.options)
    } else {
      api.reload('26004f28', component.options)
    }
    module.hot.accept("./Download.vue?vue&type=template&id=26004f28", function () {
      api.rerender('26004f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Download.vue"
export default component.exports